<h2 mat-dialog-title>{{ 'settings.title' | translate }}</h2>

<mat-dialog-content>

  <!-- Language -->
  <section class="settings-section">
    <p class="description">{{ 'settings.language.description' | translate }}</p>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'settings.language.label' | translate }}</mat-label>
      <mat-select
        [value]="selectedLanguage()"
        (selectionChange)="onLanguageChange($event)"
      >
        @for (language of availableLanguages; track language.code) {
          <mat-option [value]="language.code">
            {{ language.labelKey | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </section>

  <mat-divider />

  <!-- Form Items View -->
  <section class="settings-section">
    <p class="description">{{ 'settings.form-items-view.description' | translate }}</p>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'settings.form-items-view.label' | translate }}</mat-label>
      <mat-select
        [value]="selectedFormItemsView()"
        (selectionChange)="onFormItemsViewChange($event)"
        data-testid="settings-form-items-view-select"
      >
        @for (view of availableFormItemsViews; track view.value) {
          <mat-option
            [value]="view.value"
            [attr.data-testid]="'settings-form-items-view-option-' + view.value"
          >
            {{ view.labelKey | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </section>

  <mat-divider />

  <!-- Appearance -->
  <section class="settings-section">
    <p class="section-title">{{ 'settings.theme.title' | translate }}</p>

    <!-- Mode -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'settings.theme.mode.label' | translate }}</mat-label>
      <mat-select
        [value]="selectedMode()"
        (selectionChange)="onModeChange($event)"
      >
        <!-- Custom trigger: show icon + label in the closed select -->
        <mat-select-trigger>
          @if (currentModeOption(); as m) {
            <div class="select-option">
              <mat-icon>{{ m.icon }}</mat-icon>
              <span>{{ m.labelKey | translate }}</span>
            </div>
          }
        </mat-select-trigger>

        @for (m of availableModes; track m.value) {
          <mat-option [value]="m.value">
            <div class="select-option">
              <mat-icon>{{ m.icon }}</mat-icon>
              <span>{{ m.labelKey | translate }}</span>
            </div>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Palette -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'settings.theme.palette.label' | translate }}</mat-label>
      <mat-select
        [value]="selectedPalette()"
        (selectionChange)="onPaletteChange($event)"
      >
        <!-- Custom trigger: show swatch + label in the closed select -->
        <mat-select-trigger>
          @if (currentPaletteOption(); as p) {
            <div class="select-option">
              <span class="palette-swatch" [style.background]="p.swatch"></span>
              <span>{{ p.labelKey | translate }}</span>
            </div>
          }
        </mat-select-trigger>

        @for (p of availablePalettes; track p.value) {
          <mat-option [value]="p.value">
            <div class="select-option">
              <span class="palette-swatch" [style.background]="p.swatch"></span>
              <span>{{ p.labelKey | translate }}</span>
            </div>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </section>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'common.close' | translate }}</button>
</mat-dialog-actions>
